import {
	ORG_SETTINGS_AUDIT_TRAIL_ACTION_TYPES,
	OrgSettingsAuditTrailActions,
	OrgSettingsAuditTrailState,
} from './types'

const initialState: OrgSettingsAuditTrailState = {
	list: [],
	count: 0,
	filters: {
		multiSelectionFilters:{
			activity: []
		},
		singleSelectionFilters:{
 			userName: '',
			timestamp: undefined
		}
	},
}

export default (
	state: OrgSettingsAuditTrailState = initialState,
	action: OrgSettingsAuditTrailActions
): OrgSettingsAuditTrailState => {
	switch (action.type) {
		case ORG_SETTINGS_AUDIT_TRAIL_ACTION_TYPES.GET: {
			return {
				...state,
				list: action.payload.list,
				count: action.payload?.count || 0,
			}
		}
		case ORG_SETTINGS_AUDIT_TRAIL_ACTION_TYPES.RESET: {
			return {
				...state,
				count: 0,
				list: [],
			}
		}
		case ORG_SETTINGS_AUDIT_TRAIL_ACTION_TYPES.SET_FILTER_MULTI_SELECTION_VALUE: {
			return {
				...state,
				filters: {
					...state.filters,
					multiSelectionFilters:{
						[action.payload.key]: action.payload.value,
					}
				},
			}
		}
		case ORG_SETTINGS_AUDIT_TRAIL_ACTION_TYPES.SET_FILTER_SINGLE_SELECTION_VALUE: {
			return {
				...state,
				filters: {
					...state.filters,
					singleSelectionFilters:{
						[action.payload.key]: action.payload.value,
					}
				},
			}
		}
		default: {
			return state
		}
	}
}
